module.exports = __webpack_public_path__ + "static/media/Riku.69de1cb8.PNG";